import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type { CatalogApplication } from '#/domain/catalog/CatalogApplication'

export class GetCatalogApplicationListUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(): Promise<CatalogApplication[]> {
    return this.repository.findApplications()
  }
}
